export const SITE_TYPE = "MAKESHOP";

export const MAKESHOP_PAGE = {
  LOGIN: {
    target: `${SITE_TYPE}:LOGIN`,
    url: "/shop/member.html",
    params: [
      {
        key: "type",
        value: "login",
      },
    ],
  },
  LOGIN_MY_PAGE: {
    target: `${SITE_TYPE}:LOGIN_MY_PAGE`,
    url: "/shop/member.html",
    params: [
      {
        key: "type",
        value: "mynewmain",
      },
    ],
  }, // 마이 페이지 진입 전 로그인 페이지
  FIND_PASSWORD: {
    target: `${SITE_TYPE}:FIND_PASSWORD`,
    url: "/shop/lostpass.html",
  },
  SIGNUP: { target: `${SITE_TYPE}:SIGNUP`, url: "/shop/idinfo.html" },
  SIGNUP_COMPLETE: {
    target: `${SITE_TYPE}:SIGNUP_COMPLETE`,
    url: "/shop/join_complete.html",
  },
  MY_PAGE: { target: `${SITE_TYPE}:MY_PAGE`, url: "/shop/mypage.html" },
  FAQ: { target: `${SITE_TYPE}:FAQ`, url: "/shop/faq.html" },
  CART: { target: `${SITE_TYPE}:CART`, url: "/shop/basket.html" },
  PRODUCT_LIST: {
    target: `${SITE_TYPE}:PRODUCT_LIST`,
    url: "/shop/shopbrand.html",
  },
  PRODUCT_DETAIL: {
    target: `${SITE_TYPE}:PRODUCT_DETAIL`,
    url: "/shop/shopdetail.html",
  },
} as const;
